import { ReactElement } from 'react';

export interface DerivationStep {
  label: string;
  value: string;
  isResult?: boolean;
}

interface Props {
  steps: DerivationStep[];
}

export default function DerivationChain({ steps }: Props): ReactElement {
  return (
    <div className="cr-flex cr-flex-col cr-gap-1">
      {steps.map((step, i) => {
        const resultClasses = step.isResult
          ? 'cr-font-semibold cr-text-blue-900 cr-pt-1 cr-border-t cr-border-gray-100'
          : '';
        return (
          <div
            key={i}
            className={`cr-flex cr-justify-between cr-items-center cr-text-sm ${resultClasses}`}
          >
            <span className="cr-text-gray-700">{step.label}</span>
            <span className="cr-font-mono">{step.value}</span>
          </div>
        );
      })}
    </div>
  );
}
